import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './bestsellingweb.css';

export default class BestSellingWeb extends Component {
    render() {
        return (
            <>
            <div className="besst-sellinng-com-webversion-main-sectionx">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="best-sellnng-wexv-dot-main-sec-bboxx-web-version">
                                <div className="besstt-selling-dott-ccm-dealmmnnff-bb-web-verrsn">
                                    <p><span><img src={require('../../../assets/best-selling-web-icon.svg')} alt="orponbd global collections"/></span> Best Selling</p>
                                    <Link to="/best-selling-all-products"><span>View More <i className="fa fa-angle-right"></i></span></Link>
                                </div>

                                <div className="row besst-sellng-com-delproj-rww-webb-versnn">
                                    <div className="col-md-2 col-6">
                                        <div className="besst-sellng-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="besst-seellngg-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-13.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="besst-seelng-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <div className="bessttt-selllng-start-rattng">
                                                        <span className="fa fa-star checked"></span>
                                                        <span className="besstt-sellng-ttotl-star-rat-count">4.5</span>
                                                        {/* <span class="fa fa-star checked"></span>
                                                        <span class="fa fa-star checked"></span>
                                                        <span class="fa fa-star"></span>
                                                        <span class="fa fa-star"></span> */}
                                                        <span className="besst-selling-star-count-number">(150 Sold)</span>
                                                    </div>
                                                    <div className="bestt-sell-priicice-web-vvrsn">
                                                        <h3><span>৳</span> 1200</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="besst-sellng-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="besst-seellngg-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-14.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="besst-seelng-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <div className="bessttt-selllng-start-rattng">
                                                        <span class="fa fa-star checked"></span>
                                                        <span className="besstt-sellng-ttotl-star-rat-count">4.5</span>
                                                        <span className="besst-selling-star-count-number">(150 Sold)</span>
                                                    </div>
                                                    <div className="bestt-sell-priicice-web-vvrsn">
                                                        <h3><span>৳</span> 1200</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="besst-sellng-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="besst-seellngg-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-15.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="besst-seelng-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <div className="bessttt-selllng-start-rattng">
                                                        <span class="fa fa-star checked"></span>
                                                        <span className="besstt-sellng-ttotl-star-rat-count">4.5</span>
                                                        <span className="besst-selling-star-count-number">(150 Sold)</span>
                                                    </div>
                                                    <div className="bestt-sell-priicice-web-vvrsn">
                                                        <h3><span>৳</span> 1200</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="besst-sellng-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="besst-seellngg-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-16.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="besst-seelng-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <div className="bessttt-selllng-start-rattng">
                                                        <span class="fa fa-star checked"></span>
                                                        <span className="besstt-sellng-ttotl-star-rat-count">4.5</span>
                                                        <span className="besst-selling-star-count-number">(150 Sold)</span>
                                                    </div>
                                                    <div className="bestt-sell-priicice-web-vvrsn">
                                                        <h3><span>৳</span> 1200</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="besst-sellng-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="besst-seellngg-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-17.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="besst-seelng-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <div className="bessttt-selllng-start-rattng">
                                                        <span class="fa fa-star checked"></span>
                                                        <span className="besstt-sellng-ttotl-star-rat-count">4.5</span>
                                                        <span className="besst-selling-star-count-number">(150 Sold)</span>
                                                    </div>
                                                    <div className="bestt-sell-priicice-web-vvrsn">
                                                        <h3><span>৳</span> 1200</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="besst-sellng-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="besst-seellngg-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-18.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="besst-seelng-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <div className="bessttt-selllng-start-rattng">
                                                        <span class="fa fa-star checked"></span>
                                                        <span className="besstt-sellng-ttotl-star-rat-count">4.5</span>
                                                        <span className="besst-selling-star-count-number">(150 Sold)</span>
                                                    </div>
                                                    <div className="bestt-sell-priicice-web-vvrsn">
                                                        <h3><span>৳</span> 1200</h3>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}
